module.exports = __webpack_public_path__ + "img/TinyTAN_Sweet_Dreams_01.71c7bf4b.png";